/*jshint esversion: 11 */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge,
  Tooltip
} from 'reactstrap';
import { batch, connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import { getOfferingInfo, getOfferingList } from '../../api/offering';
import moment from 'moment';
import CreateOfferingModal from './CreateOfferingModal';
import ViewOfferingModal from './ViewOfferingModal';
import UpdateOfferingModal from './UpdateOfferingModal';
import { validatePermissionKey } from '../../helpers/permission';
import {
  CREATE_OFFERING,
  DELETE_OFFERING,
  UPDATE_OFFERING,
  VIEW_WEEKLY_ACTION_RECORD_TEMPLATE,
  CREATE_WEEKLY_ACTION_RECORD
} from '../Utility/PermissionKeys';
import validator from 'validator';
import { stringify as QStringify, parse as QParse } from 'qs';
import { useHistory } from 'react-router-dom';
import OfferingFilterModal from './OfferingFilterModal';
import DeleteOfferingModal from './DeleteOfferingModal';
import CreateWeeklyActionRecordTemplate from './CreateWeeklyActionRecordTemplate';

const OfferingListPage = ({ authUser }) => {
  const history = useHistory();

  const [breadcrumbItems] = useState([
    { title: 'Offerings', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [offeringListLoading, setOfferingListLoading] = useState(true);
  const [offeringList, setOfferingList] = useState([]);
  const [fullOfferingList, setFullOfferingList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [filterError, setFilterError] = useState(false);
  const [addOfferingModalOpen, setAddOfferingModalOpen] = useState(false);
  const [offeringInfo, setOfferingInfo] = useState({});
  const [offeringInfoLoading, setOfferingInfoLoading] = useState(false);
  const [offeringInfoModalOpen, setOfferingInfoModalOpen] = useState(false);
  const [updateOfferingModalOpen, setUpdateOfferingModalOpen] = useState(false);
  const [sortingRule, setSortingRule] = useState('name$asc');
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilterCount, setCurrentFilterCount] = useState(0);
  const [createdAtFilter, setCreatedAtFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [updatedAtFilter, setUpdatedAtFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [filterOfferingName, setFilterOfferingName] = useState('');
  const [deleteOfferingModalOpen, setDeleteOfferingModalOpen] = useState(false);
  const [offeringId, setOfferingId] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  let listElem = document.getElementById('offeringList');
  let linkElem = document.getElementById('offeringLink');

  useEffect(() => {
    if (listElem) listElem.classList.add('mm-active');
    if (linkElem) linkElem.classList.add('active');
    if (authUser) {
      populateSearchOptions(history?.location?.search);
    }
    // eslint-disable-next-line
  }, [authUser, linkElem, listElem]);

  const handlePagination = (page) => {
    fetchData(page, pagination.pageLimit, createQueryOptions(), sortingRule);
  };

  const fetchData = async (
    current_page = 1,
    page_limit = 10,
    queryOptions = {},
    sortingOption = sortingRule
  ) => {
    setOfferingListLoading(true);
    const response = await getOfferingList(
      current_page,
      page_limit,
      queryOptions,
      sortingOption
    );

    if (response) {
      setPagination({
        currentPage: response.metadata.page,
        pageLimit: response.metadata.limit,
        totalPages: response.metadata.total_pages,
        totalEntries: response.metadata.total_results
      });
      setOfferingList(response.data);
      setOfferingListLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async (
      current_page = 1,
      page_limit = 200,
      queryOptions = {},
      sortingOption = sortingRule
    ) => {
      const response = await getOfferingList(
        current_page,
        page_limit,
        queryOptions,
        sortingOption
      );
      setFullOfferingList(response?.data);

    };

    fetchData(1, 200);
  }, []);

  /**
   *
   * @param {string} str
   */
  function getValidDateInput(str) {
    return validator.isDate(str) ? new Date(str).toISOString() : '';
  }

  function createQueryOptions(
    createdStart = createdAtFilter.startDate,
    createdEnd = createdAtFilter.endDate,
    updatedStart = updatedAtFilter.startDate,
    updatedEnd = updatedAtFilter.endDate,
    name = filterOfferingName,
    deletedStatus = isDeleted
  ) {
    setFilterError(false);

    if (
      (createdStart && !createdEnd) ||
      (createdEnd && !createdStart) ||
      (updatedStart && !updatedEnd) ||
      (updatedEnd && !updatedStart)
    ) {
      setFilterError('Enter valid date range');
      return;
    }
    const startDateISOStringCreatedAt = getValidDateInput(createdStart);
    const endDateISOStringCreatedAt = getValidDateInput(createdEnd);
    const startDateISOStringUpdatedAt = getValidDateInput(updatedStart);
    const endDateISOStringUpdatedAt = getValidDateInput(updatedEnd);
    const queryOptions = {
      filter_start_created_at: startDateISOStringCreatedAt,
      filter_end_created_at: endDateISOStringCreatedAt,
      filter_start_last_updated_at: startDateISOStringUpdatedAt,
      filter_end_last_updated_at: endDateISOStringUpdatedAt,
      name,
      include_deleted: deletedStatus,
      sorting_option: sortingRule
    };
    updateUrlPath(queryOptions);
    return queryOptions;
  }

  function updateFilterCount(option) {
    let count = 0;
    Object.keys(option).forEach((i) => {
      if (option[i]?.toString()?.trim()?.length > 0 && option[i] !== false) {
        count += 1;
      }
    });
    setCurrentFilterCount(count - 1);
  }

  /**
   *
   * @param {string} searchQuery
   */
  function populateSearchOptions(searchQuery) {
    const parsedQuery = QParse(searchQuery.substring(1));
    if (
      parsedQuery.filter_start_created_at &&
      parsedQuery.filter_end_created_at
    ) {
      updateDateFilterInput(
        parsedQuery.filter_start_created_at,
        parsedQuery.filter_end_created_at,
        setCreatedAtFilter
      );
    }
    if (
      parsedQuery.filter_start_last_updated_at &&
      parsedQuery.filter_end_last_updated_at
    ) {
      updateDateFilterInput(
        parsedQuery.filter_start_last_updated_at,
        parsedQuery.filter_end_last_updated_at,
        setUpdatedAtFilter
      );
    }
    setFilterOfferingName(parsedQuery.name);
    const sortingOption = parsedQuery.sorting_option || sortingRule;
    setSortingRule(sortingOption);
    updateFilterCount(parsedQuery);
    fetchData(1, null, parsedQuery, sortingOption);
  }

  /**
   *
   * @param {string} str
   * @param {function} setHook
   * @returns
   */
  function updateDateFilterInput(startStr, endStr, setHook) {
    setHook({
      startDate: new Date(startStr),
      endDate: new Date(endStr)
    });
  }

  function updateUrlPath(queryOptions) {
    const queryString = QStringify(queryOptions);
    history.replace(`/offerings?${queryString}`);
  }

  async function fetchSortedList(sortingOption) {
    setSortingRule(sortingOption);
    const queryOptions = createQueryOptions();
    queryOptions.sorting_option = sortingOption;
    updateUrlPath(queryOptions);
    fetchData(1, null, queryOptions, sortingOption);
  }

  function openFilterModal() {
    setFilterModalOpen(true);
  }

  function closeFilterModal() {
    setFilterModalOpen(false);
  }

  function openAddOfferingModal() {
    setAddOfferingModalOpen(true);
  }

  function closeAddOfferingModal() {
    setAddOfferingModalOpen(false);
  }

  function openOfferingInfoModal(roleId) {
    fetchOfferingInfo(roleId);
    setOfferingInfoModalOpen(true);
  }

  function closeOfferingInfoModal() {
    setOfferingInfoModalOpen(false);
  }

  async function openUpdateOfferingModal(offeringId) {
    fetchOfferingInfo(offeringId);
    setUpdateOfferingModalOpen(true);
  }

  function closeUpdateOfferingModal() {
    setUpdateOfferingModalOpen(false);
  }

  async function openDeleteOfferingModal(offeringId, requestType) {
    setOfferingId({
      offeringId,
      requestType
    });
    setDeleteOfferingModalOpen(true);
  }

  function closeDeleteOfferingModal() {
    setDeleteOfferingModalOpen(false);
  }

  async function fetchOfferingInfo(offeringId) {
    setOfferingInfoLoading(true);
    const response = await getOfferingInfo(offeringId);
    if (response) {
      setOfferingInfo(response);
      setOfferingInfoLoading(false);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <OfferingFilterModal
          filterError={filterError}
          setFilterError={setFilterError}
          modalOpenState={filterModalOpen}
          closeModalHandler={closeFilterModal}
          fetchList={fetchData}
          updateFilterCount={updateFilterCount}
          updateUrlPath={updateUrlPath}
          offeringName={filterOfferingName}
          setOfferingName={setFilterOfferingName}
          createdAtFilter={createdAtFilter}
          setCreatedAtFilter={setCreatedAtFilter}
          updatedAtFilter={updatedAtFilter}
          setUpdatedAtFilter={setUpdatedAtFilter}
          createQueryOptions={createQueryOptions}
          authUser={authUser}
          isDeleted={isDeleted}
          setIsDeleted={setIsDeleted}
        />
        <CreateOfferingModal
          modalOpenState={addOfferingModalOpen}
          closeModalHandler={closeAddOfferingModal}
          fetchNewOfferingList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
        />
        <ViewOfferingModal
          modalOpenState={offeringInfoModalOpen}
          closeModalHandler={closeOfferingInfoModal}
          offeringInfo={offeringInfo}
          offeringInfoLoading={offeringInfoLoading}
        />
        <UpdateOfferingModal
          modalOpenState={updateOfferingModalOpen}
          closeModalHandler={closeUpdateOfferingModal}
          offeringInfo={offeringInfo}
          offeringInfoLoading={offeringInfoLoading}
          fetchNewOfferingList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
        />
        {offeringId && (
          <DeleteOfferingModal
            modalOpenState={deleteOfferingModalOpen}
            closeModalHandler={closeDeleteOfferingModal}
            offeringId={offeringId.offeringId}
            type={offeringId.requestType}
            fetchNewData={async () => {
              let options = await createQueryOptions();
              if (options) {
                await fetchData(1, null, options);
              }
            }}
          />
        )}

        {reportModalOpen && (
          <CreateWeeklyActionRecordTemplate
            modalOpenState={reportModalOpen}
            offeringList={fullOfferingList}
            closeModalHandler={() => setReportModalOpen(false)}
            authUser={authUser}
          />
        )}

        <Container fluid>
          <Breadcrumbs
            title="View Offerings"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <>
                    <Row className="mt-2">
                      <Col md="2">
                        <FormGroup>
                          <Col md="12">
                            <Label className="col-form-label">
                              Show Entries
                            </Label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                fetchData(
                                  1,
                                  e.target.value,
                                  createQueryOptions(),
                                  sortingRule
                                );
                                setPagination({
                                  ...pagination,
                                  pageLimit: e.target.value
                                });
                              }}
                              value={pagination.pageLimit}
                              disabled={offeringListLoading}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <Label className="col-form-label">
                            Sort Offering
                          </Label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              fetchSortedList(e.target.value);
                            }}
                            value={sortingRule}
                            disabled={offeringListLoading}
                          >
                            <option value="name$asc">
                              Offering Name (A-Z)
                            </option>
                            <option value="name$desc">
                              Offering Name (Z-A)
                            </option>
                            <option value="created_at$desc">
                              Create Time (Newest First)
                            </option>
                            <option value="created_at$asc">
                              Create Time (Oldest First)
                            </option>
                            <option value="updated_at$desc">
                              Update Time (Newest First)
                            </option>
                            <option value="updated_at$asc">
                              Update Time (Oldest First)
                            </option>
                          </select>
                        </FormGroup>
                      </Col>
                      <Col className="d-flex justify-content-end align-items-center">
                        <Button
                          size="sm"
                          color="primary"
                          className=" waves-effect waves-light mr-3"
                          onClick={openFilterModal}
                        >
                          <i className="ri-filter-fill align-middle mr-2"></i>
                          <span>Filter Offering</span>
                          {currentFilterCount > 0 && (
                            <Badge color="light" pill className="ml-2">
                              {currentFilterCount}
                            </Badge>
                          )}
                        </Button>

                        {/* {validatePermissionKey(authUser, VIEW_WEEKLY_ACTION_RECORD_TEMPLATE) && (
                          <Button
                            size="sm"
                            color="warning"
                            className=" waves-effect waves-light mr-3"
                          onClick={() => setReportModalOpen(true)}
                          >
                            <i className="bi bi-file-earmark-fill align-middle mr-2"></i>
                            Add Weekly Record
                          </Button>
                        )} */}

                        {validatePermissionKey(authUser, CREATE_OFFERING) && (
                          <Button
                            size="sm"
                            color="success"
                            className=" waves-effect waves-light"
                            onClick={openAddOfferingModal}
                          >
                            <i className="ri-add-line align-middle mr-2"></i>
                            Add Offering
                          </Button>
                        )}
                      </Col>
                    </Row>
                    {offeringListLoading ? (
                      <div className="text-center">
                        <PageDataLoader />
                      </div>
                    ) : (
                      <div className="table-rep-plugin">
                        <div
                          className="table-responsive mb-0"
                          data-pattern="priority-columns"
                        >
                          <Table
                            id="tech-companies-1"
                            striped
                            bordered
                            responsive
                          >
                            <thead>
                              <tr>
                                <th>SL. No</th>
                                <th>Name</th>
                                <th>Created At</th>
                                <th>Last Updated At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {offeringList?.map((item, index) => (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{item.name}</td>
                                  <td>
                                    {moment(new Date(item.createdAt)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>
                                  <td>
                                    {moment(new Date(item.updatedAt)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      size="sm"
                                      color="primary"
                                      className=" waves-effect waves-light mr-2 mb-2"
                                      onClick={() => {
                                        openOfferingInfoModal(item._id);
                                      }}
                                    >
                                      <i className="fas fa-eye mr-2"></i>
                                      View
                                    </Button>
                                    {validatePermissionKey(
                                      authUser,
                                      UPDATE_OFFERING
                                    ) && (
                                        <Button
                                          size="sm"
                                          color="warning"
                                          className=" waves-effect waves-light mr-2 mb-2"
                                          onClick={() => {
                                            openUpdateOfferingModal(item._id);
                                          }}
                                        >
                                          <i className="fas fa-edit mr-2"></i>
                                          Edit
                                        </Button>
                                      )}
                                    {
                                      validatePermissionKey(
                                        authUser,
                                        CREATE_WEEKLY_ACTION_RECORD
                                      ) && (
                                        <Button
                                          id={`tooltip-target-${item._id}`}
                                          size="sm"
                                          color="success"
                                          className=" waves-effect waves-light mr-2 mb-2"
                                          disabled={item.batch_ids.length === 0}
                                          onClick={() => {
                                            history.push({
                                              pathname: '/offerings/bulk-create-weekly-record',
                                              state: {
                                                batchId: item.batch_ids[0]
                                              }
                                            });
                                          }}
                                        >
                                          <i className="bi bi-file-earmark-fill mr-2"></i>
                                          Add Weekly Record
                                        </Button>
                                      )
                                    }
                                    {item.batch_ids.length === 0 && (
                                      <Tooltip
                                        placement="top"
                                        isOpen={tooltipOpen}
                                        target={`tooltip-target-${item._id}`}
                                        toggle={toggleTooltip}
                                      >
                                        No Batches
                                      </Tooltip>
                                    )}
                                    {validatePermissionKey(
                                      authUser,
                                      DELETE_OFFERING
                                    ) && (
                                        <Button
                                          size="sm"
                                          color="danger"
                                          className=" waves-effect waves-light mb-2"
                                          onClick={() => {
                                            openDeleteOfferingModal(
                                              item._id,
                                              item.isDeleted
                                                ? 'restore'
                                                : 'delete'
                                            );
                                          }}
                                        >
                                          {item.isDeleted ? (
                                            <i className="fas fa-trash-restore mr-2"></i>
                                          ) : (
                                            <i className="fas fa-trash mr-2"></i>
                                          )}
                                          {item.isDeleted ? 'Restore' : 'Delete'}
                                        </Button>
                                      )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}
                    <Row className="mt-2">
                      <Col md="5">
                        <p>
                          <strong>
                            {' '}
                            Showing{' '}
                            {(pagination.currentPage - 1) *
                              pagination.pageLimit +
                              1}{' '}
                            to{' '}
                            {Math.min(
                              pagination.currentPage * pagination.pageLimit,
                              pagination.totalEntries
                            )}{' '}
                            of {pagination.totalEntries} entries
                          </strong>
                        </p>
                      </Col>
                      {!offeringListLoading && offeringList.length > 0 && (
                        <Col md="7">
                          <Paginator
                            totalPages={pagination.totalPages}
                            currentPage={pagination.currentPage}
                            changePage={handlePagination}
                          />
                        </Col>
                      )}
                    </Row>
                  </>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(OfferingListPage);
